/* layout lines */
import { pageTrackingResolver } from './tracking/pageTracking.resolver';

/* common lines */
import { destinationsResolver } from './destinations/destinations.resolver';
import { editorialFoldingBlockResolver } from './editorial-folding-block/editorialFoldingBlock.resolver';
import { eventFormResolver } from './event-form/eventForm.resolver';
import { immersiveResolver } from './immersive/immersive.resolver';
import { instagramResolver } from './instagram/instagram.resolver';
import { mediaTextHorizontalResolver } from './media-text-horizontal/mediaTextHorizontal.resolver';
import { mediaTextVerticalResolver } from './media-text-vertical/mediaTextVertical.resolver';
import { navigationTabsResolver } from './navigation-tabs/navigationTabs.resolver';
import { offersGridResolver } from './offers-grid/offersGrid.resolver';
import { prebookingFormResolver } from './prebooking-form/prebookingForm.resolver';
import { productsFiltersResolver } from './products-filters/productsFilters.resolver';
import { productsGridResolver } from './products-grid/productsGrid.resolver';
import { productTagsResolver } from './product-tags/productTags.resolver';
import { sectionsResolver } from './sections/sections.resolver';
import { tabResolver } from './tab/tab.resolver';
import { teaserCardsResolver } from './teaser-cards/teaserCards.resolver';
import { titleAndTextResolver } from './title-and-text/titleAndText.resolver';

/* country lines : webedia countryId needed */
import { countryEventsResolver } from './country-events/countryEvents.resolver';
import { countryInfosResolver } from './country-infos/countryInfos.resolver';
import { countryIntroductionResolver } from './country-introduction/countryIntroduction.resolver';
import { countryPoiResolver } from './country-poi/countryPoi.resolver';

/* offer lines : offerId needed */
import { offerDescriptionResolver } from './offer-description/offerDescription.resolver';
import { offerLegalInformationResolver } from './offer-legal-information/offerLegalInformation.resolver';
import { offerSEOResolver } from './offer-seo/offerSeo.resolver';

/* cruise lines : resortId/productId needed (only cruise ID) */
import { cruiseBookingResolver } from './cruise-booking/cruiseBooking.resolver';
import { cruiseProgramResolver } from './cruise-program/cruiseProgram.resolver'; // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */
import { productAccessAndMapResolver } from './product-access-and-map/productAccessAndMap.resolver';
import {
  productAccommodationsResolver,
  productAccommodationsExclusiveCollectionResolver,
} from './product-accommodations/productAccommodations.resolver';
import { productActivitiesResolver } from './product-activities/productActivities.resolver';
import { productBarsResolver } from './product-bars/productBars.resolver';
import { productBookingBEResolver } from './product-booking/productBookingBE.resolver';
import { productBreadcrumbResolver } from './product-breadcrumb/productBreadcrumb.resolver';
import { productChildcaresResolver } from './product-childcares/productChildcares.resolver';
import { productCommunityQuestionsResolver } from './product-community-questions/productCommunityQuestions.resolver';
import { productDestinationResolver } from './product-destination/productDestination.resolver';
import { productFlashInfoResolver } from './product-flash-info/productFlashInfo.resolver';
import { productGoogleStreetViewResolver } from './product-google-street-view/productGoogleStreetView.resolver';
import { productImageMapResolver } from './product-image-map/productImageMap.resolver';
import { productImmersiveResolver } from './product-immersive/productImmersive.resolver';
import { productInformationSummaryResolver } from './product-information-summary/productInformationSummary.resolver';
import { productInstagramResolver } from './product-instagram/productInstagram.resolver';
import { productIntroductionResolver } from './product-introduction/productIntroduction.resolver';
import { productMeetingRoomInfoResolver } from './product-meeting-room-info/productMeetingRoomInfo.resolver';
import { productMultimediaResolver } from './product-multimedia/productMultimedia.resolver';
import { productMustTryExperiencesResolver } from './product-must-try-experiences/productMustTryExperiences.resolver';
import { productPriceRemoteResolver } from './product-price-remote/productPriceRemote.resolver';
import { productPriceTicketResolver } from './product-price-ticket/productPriceTicket.resolver';
import { productPriceTicketCustomResolver } from './product-price-ticket-custom/productPriceTicketCustom.resolver';
import { productQuotationFormResolver } from './product-quotation-form/productQuotationForm.resolver';
import { productRecommendationsResolver } from './product-recommendations/productRecommendations.resolver';
import { productRelatedProductsResolver } from './product-related-products/productRelatedProducts.resolver';
import { productRestaurantsResolver } from './product-restaurants/productRestaurants.resolver';
import { productSEOTitleResolver } from './product-seo-title/productSEOTitle.resolver';
import { productServicesResolver } from './product-services/productServices.resolver'; // no ID but commonly on product page
import { productSpaceIntroductionResolver } from './product-space-introduction/productSpaceIntroduction.resolver';
import { productStrengthsResolver } from './product-strengths/productStrengths.resolver';
import { productSummaryResolver } from './product-summary/productSummary.resolver';
import { productTripadvisorResolver } from './product-tripadvisor/productTripadvisor.resolver';
import { productWellnessResolver } from './product-wellness/productWellness.resolver';
import { productWellnessLegacyResolver } from './product-wellness-legacy/productWellnessLegacy.resolver';

/* tour lines : resortId/productId needed (only tour ID) */
import { tourIntroductionResolver } from './tour-introduction/tourIntroduction.resolver';
import { tourPracticalInformationResolver } from './tour-practical-information/tourPracticalInformation.resolver';
import { tourProgramResolver } from './tour-program/tourProgram.resolver';

const resolvers = [
  countryEventsResolver,
  countryInfosResolver,
  countryIntroductionResolver,
  countryPoiResolver,
  cruiseBookingResolver,
  cruiseProgramResolver,
  destinationsResolver,
  editorialFoldingBlockResolver,
  eventFormResolver,
  immersiveResolver,
  instagramResolver,
  mediaTextHorizontalResolver,
  mediaTextVerticalResolver,
  navigationTabsResolver,
  offerDescriptionResolver,
  offersGridResolver,
  offerLegalInformationResolver,
  offerSEOResolver,
  pageTrackingResolver,
  prebookingFormResolver,
  productAccessAndMapResolver,
  productAccommodationsExclusiveCollectionResolver,
  productAccommodationsResolver,
  productActivitiesResolver,
  productBarsResolver,
  productBookingBEResolver,
  productBreadcrumbResolver,
  productChildcaresResolver,
  productCommunityQuestionsResolver,
  productDestinationResolver,
  productFlashInfoResolver,
  productGoogleStreetViewResolver,
  productImageMapResolver,
  productImmersiveResolver,
  productInformationSummaryResolver,
  productInstagramResolver,
  productIntroductionResolver,
  productMeetingRoomInfoResolver,
  productMultimediaResolver,
  productMustTryExperiencesResolver,
  productPriceRemoteResolver,
  productPriceTicketResolver,
  productPriceTicketCustomResolver,
  productQuotationFormResolver,
  productRecommendationsResolver,
  productRelatedProductsResolver,
  productRestaurantsResolver,
  productSEOTitleResolver,
  productServicesResolver,
  productSpaceIntroductionResolver,
  productStrengthsResolver,
  productSummaryResolver,
  productTagsResolver,
  productTripadvisorResolver,
  productWellnessResolver,
  productWellnessLegacyResolver,
  productsFiltersResolver,
  productsGridResolver,
  sectionsResolver,
  tabResolver,
  teaserCardsResolver,
  titleAndTextResolver,
  tourIntroductionResolver,
  tourPracticalInformationResolver,
  tourProgramResolver,
];

export const resolversLibrary = resolvers.reduce((acc, resolver) => {
  if (acc[resolver.name]) {
    throw new Error(`A resolver named ${resolver.name} is already set.`);
  }

  acc[resolver.name] = resolver;

  return acc;
}, {});

export type ResolversLibrary = { [$Keys<typeof resolversLibrary>]: Descriptor };
